import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { DropdownOptions, MoreOptionsButton } from '@netexknowledge/smart-components';
import { useIsMobile } from '../../../utils/mobileUtils';
import ActionSheet from './ActionSheet';

const stopPropagation = event => event.stopPropagation();
const isolatedEvents = { onClick: stopPropagation, onMouseDown: stopPropagation, onTouchStart: stopPropagation };

const MoreOptions = ({ id, color, dropdownSide, options, sheetTitle, sheetOverline, sheetMedia }) => {
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);

  if (!isMobile) {
    return <DropdownOptions id={id} color={color} dropdownSide={dropdownSide} options={options} />;
  }

  return (
    <span className="more-options" {...isolatedEvents}>
      <MoreOptionsButton
        id={`selector-${id}`}
        color={color || 'gray'}
        active={open}
        aria-label={I18n.t('mobileSheets.moreOptions')}
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={event => {
          event.currentTarget.blur();
          setOpen(true);
        }}
      />
      <ActionSheet
        open={open}
        onClose={() => setOpen(false)}
        options={options}
        title={sheetTitle}
        overline={sheetOverline}
        media={sheetMedia}
      />
    </span>
  );
};

MoreOptions.propTypes = {
  id: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['white', 'black', 'gray']),
  dropdownSide: PropTypes.oneOf(['left', 'right']),
  options: PropTypes.array.isRequired,
  sheetTitle: PropTypes.node,
  sheetOverline: PropTypes.node,
  sheetMedia: PropTypes.node
};

export default MoreOptions;
